<div class="content-upload-file" [ngClass]="{'disabled': disabled}">
    <div class="box-input" #boxInput [ngClass]="{'error-file': errors}">
        <input type="file" class="input-file" id="file" #inputFile [disabled]="disabled">
        <label for="file" [innerHTML]="labelInput"></label>
    </div>
    <button *ngIf="active || errors" (click)="clear()" mat-mini-fab><mat-icon>close</mat-icon></button>
</div>